import { render } from "./FooterGA.vue?vue&type=template&id=124b10a7&scoped=true"
import script from "./FooterGA.vue?vue&type=script&lang=js"
export * from "./FooterGA.vue?vue&type=script&lang=js"

import "./FooterGA.vue?vue&type=style&index=0&id=124b10a7&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124b10a7"]])

export default __exports__